// const baseUrl = "http://localhost/photogallery/public/api";
const baseUrl = "https://albums.frameophotography.in/backend/public/api";

export default baseUrl;